import {FLYOUT_PORTAL} from './portalIds';
import {usePortalElement} from './usePortalElement';

export function useFlyoutPortalElement() {
  return usePortalElement(FLYOUT_PORTAL);
}
